module.exports = __webpack_public_path__ + "static/media/001B_infopanel.f1422005.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/google/001B_infopanel.png
// module id = 458
// module chunks = 0